import { createContext, useContext, Dispatch, SetStateAction} from 'react';
import { Socket } from 'socket.io-client';
import { Notification } from 'src/models/notification';

export interface NotificationContextType {
  notifications: Notification[];
  socket: Socket | null;
  setNotifications: Dispatch<SetStateAction<Notification[]>>;
}

export const NotificationContext = createContext<NotificationContextType>(
  {} as NotificationContextType
);

export const useSocket = (): NotificationContextType => {
  return useContext(NotificationContext);
};